<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="part" id="pt02">
<h1 class="pn"><a class="page" id="p39"></a><a class="xref" href="#/chiminteer0007#rpt02"><span class="sm">PART</span> <span class="sm">II</span></a></h1>
<h1 class="pt">The Rise of US Zoo and Aquarium Conservation in the Nineteenth and Twentieth Centuries</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-minteer-0013.vue?07768bdc